import { Star, ShieldHalf } from "lucide-react";
import PlayerAvatar from "./PlayerAvatar";
import { shortName } from "../../utils/football";
import { hapticLight } from "../../utils/haptics";

const Row = ({ player, selected, onClick, kind, testid }) => (
  <button
    type="button"
    onClick={() => { hapticLight(); onClick(player.player_id); }}
    className={`flex w-full items-center gap-3 rounded-lg border px-3 py-2.5 text-left transition-colors ${
      selected ? "border-amber-400 bg-amber-400/10" : "border-border bg-card"
    }`}
    data-testid={testid}
  >
    <PlayerAvatar player={player} size={36} />
    <div className="min-w-0 flex-1">
      <div className="truncate text-sm font-semibold">{shortName(player.name)}</div>
      <div className="text-xs text-muted-foreground">{player.position} · {player.team_name}</div>
    </div>
    {selected && (kind === "C"
      ? <Star size={18} className="wc-gold fill-amber-400" />
      : <ShieldHalf size={18} className="text-slate-300" />)}
  </button>
);

export const CaptainSelector = ({ squad, onSetCaptain, onSetVC }) => {
  const main = squad.filter((p) => !p.is_super_sub);
  if (main.length === 0) return null;
  return (
    <div className="football-theme space-y-4" data-testid="captain-selector">
      <div>
        <h3 className="mb-2 text-sm font-bold">Captain <span className="font-normal text-muted-foreground">(2x points)</span></h3>
        <div className="space-y-2">
          {main.map((p) => (
            <Row key={`c-${p.player_id}`} player={p} selected={p.is_captain} onClick={onSetCaptain} kind="C"
              testid={`captain-pick-${p.player_id}`} />
          ))}
        </div>
      </div>
      <div>
        <h3 className="mb-2 text-sm font-bold">Vice-Captain <span className="font-normal text-muted-foreground">(1.5x · auto-promotes)</span></h3>
        <div className="space-y-2">
          {main.filter((p) => !p.is_captain).map((p) => (
            <Row key={`vc-${p.player_id}`} player={p} selected={p.is_vice_captain} onClick={onSetVC} kind="VC"
              testid={`vc-pick-${p.player_id}`} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CaptainSelector;
